import { useSuspenseQuery } from "@tanstack/react-query";
import {
	createFileRoute,
	useNavigate,
	useParams,
	useSearch,
} from "@tanstack/react-router";
import { Button } from "@/components/base/buttons/button";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { userQueryOptions } from "@/services/user";
import { SearchSchema } from "../$userId";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/users/(organization-users)/organization/$userId/",
)({
	component: IndexComponent,
	validateSearch: (search) => {
		return SearchSchema.parse(search);
	},
});

function IndexComponent() {
	const { t } = useAppTranslation();
	const navigate = useNavigate();
	const params = useParams({
		from: "/_authenticated/(admin-app)/_admin/admin/users/(organization-users)/organization/$userId/",
	});
	const search = useSearch({
		from: "/_authenticated/(admin-app)/_admin/admin/users/(organization-users)/organization/$userId/",
	});

	const userById = useSuspenseQuery(userQueryOptions.detail(params.userId));

	// const editForm = useEditUserForm(params.userId);

	const isViewMode = search.mode === "view";

	return (
		<div className="space-y-6">
			<div className="flex items-center justify-between">
				<div>
					<h3 className="text-lg font-semibold text-gray-900">
						{t("admin.users.tabs.organization.details.title")}
					</h3>
					<p className="text-sm text-gray-600">
						{t("admin.users.tabs.organization.details.description")}
					</p>
				</div>
				{isViewMode && (
					<Button
						color="primary"
						onClick={() => {
							navigate({
								to: "/admin/users/platform/$userId/details",
								params: { userId: params.userId },
								search: { mode: "edit" },
							});
						}}
					>
						{t("admin.users.tabs.organization.details.editDetails")}
					</Button>
				)}
			</div>
			<div className="bg-white rounded-lg border border-gray-200 p-6">
				{userById.isLoading ? (
					<div className="flex items-center justify-center py-8">
						<div className="text-sm text-gray-500">
							{t("common.actions.loading")}
						</div>
					</div>
				) : userById.error ? (
					<div className="flex items-center justify-center py-8">
						<div className="text-sm text-red-500">
							{t("common.actions.errorLoading")}
						</div>
					</div>
				) : (
					// biome-ignore lint/suspicious/noExplicitAny: Form types are complex and require type assertion
					// <EditOrganizationFormLayout form={editForm as any} />
					<div>{t("admin.users.tabs.organization.details.title")}</div>
				)}
			</div>
			{/* Form Actions */}
			{!isViewMode && (
				<div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
					<Button
						onClick={() => {
							navigate({
								to: "/admin/users/platform/$userId/details",
								params: { userId: params.userId },
								search: { mode: "view" },
							});
						}}
					>
						{t("common.actions.cancel")}
					</Button>
					{/* <editForm.Subscribe
						selector={(state) => [
							state.canSubmit,
							state.isSubmitting,
							state.isPristine,
						]}
					>
						{([canSubmit, isSubmitting]) => (
							<Button
								color="primary"
								disabled={!canSubmit || isSubmitting}
								onClick={() => {
									if (canSubmit) {
										editForm.handleSubmit()
									}
								}}
							>
								{isSubmitting ? "Saving..." : "Save Changes"}
							</Button>
						)}
					</editForm.Subscribe>
					*/}
				</div>
			)}
		</div>
	);
}
